<template>
    <div class="bottom-operate-wrap">
        <Checkbox name="allCheckBox" class="all-check" @valueChange="allCheckHandler" :data="allCheck" />
        <label class="all-label" for="allCheckBox">{{ allLabel }}</label>
        <Button :text="deleteBtn" :icon="deleteIcon" @btnClick="deleteHandler"></Button>
        <OptionButton
            class="transfer"
            :text="$i18n.t('zhiji.knowlege.transferTo')"
            :icon="transferIcon"
            :hover-icon="transferHoverIcon"
            :options="treeData"
            :getOptions="() => treeData"
            :multiple="true"
            @multipleSelect="multipleSelect"
        />
    </div>
</template>

<script>
import Checkbox from "@/views/zhiji/bComponents/checks/Checkbox";
import Button from "@/views/zhiji/bComponents/buttons/Button";
import { STATIC_IMG_PATH } from "@/views/zhiji/js/common/constants.js";
import OptionButton from "@/views/zhiji/bComponents/buttons/OptionButton";
import { recursionTrans } from "@/views/zhiji/js/common/util.js";

export default {
    name: "BottomOperateBar",
    props: ["allCheck"],
    components: {
        Checkbox,
        Button,
        OptionButton
    },
    data() {
        return {
            deleteIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -94px 0px",
            transferIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -191px 0px",
            transferHoverIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -191px -20px"
        };
    },
    computed: {
        allLabel() {
            return this.$t("zhiji.common.selectAll");
        },
        deleteBtn() {
            return this.$t("zhiji.common.delete");
        },
        treeData() {
            const treeData = this.$store.state.zhiji.materialLibraryPage.treeData.children || [];
            return recursionTrans(
                treeData,
                function(treesData) {
                    return {
                        value: treesData.id,
                        label: treesData.label
                    };
                },
                "children"
            );
        }
    },
    methods: {
        allCheckHandler(data) {
            this.$emit("allCheckChange", data);
        },
        deleteHandler(e) {
            this.$emit("deleteClick", e);
        },
        // 转移
        multipleSelect(datas) {
            this.$emit("transferHandle", datas)
        }
    }
};
</script>

<style scoped lang="less">
.bottom-operate-wrap {
    position: absolute;
    left: 24px;
    display: inline-flex;
    align-items: center;
    .all-check {
        margin-right: 10px;
    }
    .all-label {
        margin-right: 16px;
    }
    .transfer {
        margin-left: 16px;
    }
}
</style>
